import React from "react";
import "../../projects/mainNavView/MainNavView.scss";
import CompanyAndUser from "../../shared/companyAndUser/CompanyAndUser";

import "./PeopleNavView.scss";

const PeopleNavView = () => (
  <div className="MainNavView PeopleNavView">
    <div className="grid-container full">
      <div className="grid-x projects-header">
        <div className="cell small-10">
          <h6>
            Fastloop. <span className="u-gray">Users</span>
          </h6>
        </div>
        <div className="cell small-2">
          <CompanyAndUser />
        </div>
      </div>
    </div>
  </div>
);

export default PeopleNavView;
